export enum Language {
	ja = 0,
	en = 1,
}
